// extracted by mini-css-extract-plugin
export default {"products":"bu-z","card":"cu-z","oosMessaging":"du-z"};